import axios from 'axios';
import { URL_ROOT } from '../api/Routes';
import { LOGOUT_USER } from '../actions/loginActions';
import store from '../store';

const axiosInstance = axios.create({
  baseURL: URL_ROOT + '/api/',
  timeout: 300000,
  withCredentials: true,
});

// response interceptor for refreshing the jwt access token when it expires
axiosInstance.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    const originalRequest = error.config;
    let isRefreshTokenValid = true;
    if (
      error.response.data.message &&
      error.response.data.message === 'Invalid refresh token!'
    ) {
      isRefreshTokenValid = false;
    }

    if (!isRefreshTokenValid) {
      sessionStorage.setItem('isUserLoggedIn', false);
      axiosInstance.defaults.headers.common['Authorization'] = ``;
      store.dispatch({ type: LOGOUT_USER });
      store.dispatch({
        type: 'REFRESH_ERROR',
        errorMessage: 'Your session has expired, please log in again',
      });
      // return Error object with Promise
      return Promise.reject(error);
    } else if (
      error.response.status === 401 &&
      isRefreshTokenValid &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      axiosInstance.defaults.headers.common['Authorization'] = ``;
      return axiosInstance.post('auth/refresh', null).then(res => {
        axiosInstance.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${res.data.token}`;
        originalRequest.headers['Authorization'] = `Bearer ${res.data.token}`;

        // return originalRequest object with Axios.
        return axiosInstance(originalRequest);
      });
    }
    // return Error object with Promise
    return Promise.reject(error);
  }
);

export default axiosInstance;
